import React, { useState, Fragment } from 'react';
import { Container, Form, Button, Alert, Row, Col } from 'react-bootstrap';
import RhService from '../../../../services/rh';
import '../../../../styles/diario.scss';
import { Link } from 'react-router-dom';

const ApagarMesHolerites = () => {
    const [mes, setMes] = useState("");
    const [ano, setAno] = useState("");
    const [mensagem, setMensagem] = useState('');
    const [sucesso, setSucesso] = useState(false);


    const apagar = async () => {
        if (!mes || !ano) return;
        try {
            const response = await RhService.delMesHolerite(mes, ano);
            if (response.data["mensagem"] == "Holerites apagadas com sucesso!")
                setMensagem(response.data["mensagem"]);
            setSucesso(true);
        } catch (err) {
            setMensagem('Erro ao apagar as holerites.');
        }
    };

    if (!sucesso) {
        return (
            <Fragment>
                <Container className="mt-4">
                    <h3>Apagar holerite do mês</h3>

                    {mensagem && <Alert variant="info">{mensagem}</Alert>}

                    <Row className="mb-3">
                        <Col xs={12} lg={5}>
                            <Form.Group controlId="selectMes">
                                <Form.Label>Mês a ser apagado</Form.Label>
                                <Form.Select required value={mes} onChange={e => setMes(e.target.value)}>
                                    <option value="">SELECIONE</option>
                                    <option value="01">Janeiro</option>
                                    <option value="02">Fevereiro</option>
                                    <option value="03">Março</option>
                                    <option value="04">Abril</option>
                                    <option value="05">Maio</option>
                                    <option value="06">Junho</option>
                                    <option value="07">Julho</option>
                                    <option value="08">Agosto</option>
                                    <option value="09">Setembro</option>
                                    <option value="10">Outubro</option>
                                    <option value="11">Novembro</option>
                                    <option value="12">Dezembro</option>
                                    <option value="13">13º Salário - 1ª Parcela</option>
                                    <option value="14">13º Salário - 2ª Parcela</option>
                                    <option value="15">Informe Anual de Rendimentos</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={5}>
                            <Form.Group controlId="selectMes">
                                <Form.Label>Ano</Form.Label>
                                <Form.Select required value={ano} onChange={e => setAno(e.target.value)}>
                                    <option value="">SELECIONE</option>
                                    <option value="2025">2025</option>
                                    <option value="2026">2026</option>
                                    <option value="2027">2027</option>
                                    <option value="2028">2028</option>
                                    <option value="2029">2029</option>
                                    <option value="2030">2030</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    <br/>
                    <Row>
                        <Col xs={6} lg={2}>
                            <Button variant="danger" onClick={apagar}>Apagar Holerites</Button>
                        </Col>
                    </Row>
                    <br/>
                    <Row>
                        <Link to={'/rh/holerites'}>
                            <Button variant="danger" type="button">
                                Voltar
                            </Button>
                        </Link>
                    </Row>
                </Container>
            </Fragment>
        );
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Holerites apagadas com sucesso!</Alert>
                <Row>
                    <Link to={'/rh/holerites'}>
                        <Button variant="danger" type="button">
                            Voltar
                        </Button>
                    </Link>
                </Row>
            </Fragment>
        )
    }
}

export default ApagarMesHolerites;